import React, { Component } from 'react';
import './_rounded-rect-button.scss';
import {PropTypes} from 'prop-types';

class RoundedRectButton extends Component {

  render() {
    return (
      <button {...this.props} className="rounded-rect-button">{this.props.children}</button>
    );
  }
}

RoundedRectButton.propTypes = {
  type: PropTypes.oneOf(['button', 'submit'])
}

RoundedRectButton.defaultProps = {
  type: 'button'
}

export default RoundedRectButton;



// WEBPACK FOOTER //
// ./components/UI/Form/RoundedRectButton.jsx